import {
  Box,
  HStack,
  Image,
  KdsText,
  theme,
  VStack,
} from "@kazaar-platform/design-system";
import { RiImageEditLine } from "@remixicon/react";
import { useTranslate } from "@tolgee/react";
import { type ProductInfoBlocProps } from "./ProductInfoBloc.types";

export const ProductInfoBloc = ({
  image,
  isWithPreMedia = false,
  name,
}: ProductInfoBlocProps) => {
  const { t } = useTranslate();

  return (
    <Box p="sp-xs">
      <HStack gap="sp-md" align="center">
        <Image
          src={image}
          alt={name}
          className="w-[120px] h-[120px] rounded-br-sm rounded-br-br-sm"
        />

        <VStack gap="sp-xs2">
          <KdsText size="title-md">{name}</KdsText>

          <HStack align="center" gap="sp-xs2">
            <RiImageEditLine
              className="size-si-xs2"
              color={
                isWithPreMedia
                  ? theme.colors.primary.text
                  : theme.colors.text.bodyvariant
              }
            />
            <KdsText
              size="subtitle-xs"
              color={isWithPreMedia ? "primary-text" : "text-bodyvariant"}
            >
              {isWithPreMedia
                ? t("orderItem.productInfo.withPreMedia")
                : t("orderItem.productInfo.withoutPreMedia")}
            </KdsText>
          </HStack>
        </VStack>
      </HStack>
    </Box>
  );
};
